function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { string, number, bool, oneOfType, array } from 'prop-types';
import { Spacer } from './../../Spacer/Spacer';
import { Anchor } from './../../Anchor/Anchor';
import { Text } from './../../Text/Text';
import css from './TextEllipse.sass';

var TextEllipse =
/*#__PURE__*/
function (_Component) {
  _inherits(TextEllipse, _Component);

  function TextEllipse(props) {
    var _this;

    _classCallCheck(this, TextEllipse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextEllipse).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getContent", function (proxiedProps) {
      var _this$props = _this.props,
          content = _this$props.content,
          chars = _this$props.chars;
      if (!content) return '';
      var isString = typeof content === 'string';
      var isEllipsed = _this.state.isEllipsed;
      var text = isString ? '' : [];

      if (!_this.state.isUnFolded) {
        if (isString) {
          isEllipsed = content.length > chars;
          text = isEllipsed ? "".concat(content.slice(0, chars), "...") : content;
        } else {
          var leftChars = chars;

          for (var index = 0; index < content.length; index++) {
            if (leftChars - content[index].length > 0) {
              leftChars -= content[index].length;
              text[index] = content[index];
            } else {
              isEllipsed = true;
              text[index] = "".concat(content[index].slice(0, leftChars), "...");
              break;
            }
          }
        }
      } else {
        text = content;
      }

      if (_this.state.isEllipsed !== isEllipsed) setTimeout(function () {
        return _this.setState({
          isEllipsed: isEllipsed
        });
      });
      return isString ? React.createElement(Text, _extends({}, proxiedProps, {
        content: _this.getQuted(text)
      })) : React.createElement("ul", {
        className: css.ul
      }, text.map(function (item, index) {
        return React.createElement("li", {
          key: index,
          className: css.li
        }, React.createElement(Text, _extends({}, proxiedProps, {
          display: "inline",
          content: item
        })));
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getQuted", function (content) {
      return _this.props.quoted ? "\xAB".concat(content, "\xBB") : content;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggle", function () {
      return _this.setState({
        isUnFolded: !_this.state.isUnFolded
      });
    });

    _this.state = {
      isUnFolded: false,
      isEllipsed: false
    };
    return _this;
  }

  _createClass(TextEllipse, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var content = _ref.content;

      if (content !== this.props.content && this.state.isUnFolded) {
        this.toggle();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          moreText = _this$props2.moreText,
          lessText = _this$props2.lessText,
          showToggler = _this$props2.showToggler,
          restProps = _objectWithoutProperties(_this$props2, ["className", "moreText", "lessText", "showToggler"]);

      var _this$state = this.state,
          isUnFolded = _this$state.isUnFolded,
          isEllipsed = _this$state.isEllipsed;
      return React.createElement("div", {
        className: className
      }, this.getContent(restProps), showToggler && isEllipsed && React.createElement(Spacer, {
        marginTop: "16"
      }, React.createElement(Anchor, {
        pseudo: true,
        onClick: this.toggle
      }, isUnFolded ? lessText : moreText)));
    }
  }]);

  return TextEllipse;
}(Component);

TextEllipse.propTypes = {
  /** Toggle text for folded state */
  moreText: string,

  /** Toggle text for unfolded state */
  lessText: string,

  /** Classname */
  className: string,

  /** Html content */
  content:
  /*#__PURE__*/
  oneOfType([string, array]).isRequired,

  /** Characters quantity for ellipsed text */
  chars: number,

  /** Wrap text in quotes */
  quoted: bool,

  /** Flag to show toggler */
  showToggler: bool
};
TextEllipse.defaultProps = {
  moreText: 'Читать полностью',
  lessText: 'Свернуть',
  quoted: false,
  showToggler: true
};
TextEllipse.displayName = 'Text.Ellipse';
export { TextEllipse };